import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, CardContent } from '../../../components/ui';
import type { App } from '../../../types/app.types';

interface AppCardProps {
  app: App;
  onClick?: (app: App) => void;
}

export const AppCard = ({ app, onClick }: AppCardProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: app.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const handleClick = () => {
    // Only trigger onClick if not dragging
    if (!isDragging) {
      onClick?.(app);
    }
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Card
        className="cursor-pointer transition-all hover:scale-105 hover:shadow-lg"
        onClick={handleClick}
      >
        <CardContent className="flex flex-col items-center justify-center p-6 text-center">
          {/* Drag handle at the top */}
          <div {...attributes} {...listeners} className="mb-2 cursor-grab active:cursor-grabbing">
            <div className="text-xs text-muted-foreground">⋮⋮</div>
          </div>
          
          <div className="mb-3 text-5xl">{app.icon}</div>
          <h3 className="mb-1 font-semibold">{app.name}</h3>
          <p className="text-sm text-muted-foreground">{app.description}</p>
          <div className="mt-3">
            <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
              {app.category}
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
